import { FieldError } from 'react-hook-form';

export enum QuestionType {
    TEXT = 'text',
    BOOLEAN = 'boolean',
    NUMERIC = 'numeric',
    MULTISELECT = 'multiselect',
    FORMULA = 'formula',
}

export interface RatingScaleWeight {
    min: number;
    max: number;
    value: number;
}

export interface BaseQuestion {
    id: string;
    type: QuestionType;
    text: string;
    title?: string;
}

export interface TextQuestion extends BaseQuestion {
    type: QuestionType.TEXT;
}

export interface BooleanQuestion extends BaseQuestion {
    type: QuestionType.BOOLEAN;
}

export interface NumericQuestion extends BaseQuestion {
    type: QuestionType.NUMERIC;
    minValue: number;
    maxValue: number;
    useRatingScale?: boolean;
}

export interface MultiselectQuestion extends BaseQuestion {
    type: QuestionType.MULTISELECT;
    options: string[];
}

export interface FormulaQuestion extends BaseQuestion {
    type: QuestionType.FORMULA;
    formula: string; // Q-based formula for UI display: "Q1 + Q2 * 10"
    isQualityScore?: boolean;
}

export type CampaignQuestion = TextQuestion | BooleanQuestion | NumericQuestion | MultiselectQuestion | FormulaQuestion;
export type QuestionAnswerType = string | boolean | number | string[] | null;

export type CampaignQuestionWithAnswer =
    | (TextQuestion & { answer: QuestionAnswerType })
    | (BooleanQuestion & { answer: QuestionAnswerType })
    | (NumericQuestion & { answer: QuestionAnswerType })
    | (MultiselectQuestion & { answer: QuestionAnswerType })
    | (FormulaQuestion & { answer: QuestionAnswerType });

export interface OptionsFieldError {
    title?: FieldError;
    text?: FieldError;
    type?: FieldError;
    options?: FieldError & {
        [key: number]: FieldError;
    };
    formula?: FieldError;
}
